import React, { useState, useEffect } from "react";
import "./SchoolTeamPage.css";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";

const SchoolTeamPage = () => {

  const { school_slug } = useParams();


  const tableStyle = {
    backgroundColor: 'white',
    // border: '2px solid rgb(100, 19, 32)',
    borderCollapse: "collapse",
    width: "100%",
    maxWidth: "1000px",
    minWidth: '600px',
    color: '#333',
    borderRadius: '10px',
    overflow: 'hidden',

    margin: "0px auto",
  };
  const thStyle = {
    padding: "15px",
    border: "1px solid #ddd",
    color: "rgb(100, 19, 32)",
    textAlign: 'center',
    fontWeight: '600',

    fontFamily: 'Lora',
  };
  const tdStyle = {
    padding: '12px 15px',
    border: "1px solid #ddd",
    textAlign: "center",

  };

  const [loading, setLoading] = useState(true);


  const teamInfo = [
    {
      id: 1,
      info: "APARAJITA SARKAR",
      details: "TGT ",
    },
    { id: 2, info: "RUMPA DEY ", details: "TGT" },
    { id: 3, info: "KOYEL DAS", details: "TGT" },
    {
      id: 4,
      info: "PARAMITA BHATTACHARJEE ",
      details:
        "TGT ",
    },
    {
      id: 5,
      info: "NILANJAN KHASNOBISH ",
      details: "TGT",
    },
    {
      id: 6,
      info: "PRANAY KARMAKAR",
      details: "TGT",
    },
    { id: 7, info: "DEBANJALI CHANDA", details: "TGT" },
    {
      id: 8,
      info: "SHOVNA DUTTA ",
      details: "TGT",
    },
  ];












  // const imagePath = null;
  const imagePath = "/pictures/home/founder_desk.jpg";
  const hasImage = !!imagePath;
  return (
    <>
      {/* Hero Section */}
      <SchoolInnerPageBanner />
      <section className="principal-section">
        <div className="principal-container">

          <h2 className="principal-title">PRINCIPAL DESK</h2>



          <div className={`principal-content ${!hasImage ? "full-width" : ""}`}>
            {/* IMAGE (only if exists) */}
            {hasImage && (
              <div className="principal-profile">
                <div className="principal-image-box">
                  <img src={imagePath} alt="Principal" />
                </div>
              </div>
            )}
            {/* TEXT */}
            <div className="principal-text">
              <p>
                "At Techno India Group Public School, Alipurduar, established in 2014 and affiliated to CBSE, we strive to ignite the fire of curiosity and learning in every child. Situated in the serene surroundings of Tapsikhata, our school combines modern infrastructure with a student-friendly atmosphere, making education both meaningful and enjoyable. We provide a balanced blend of academics, values and co-curricular activities within a nurturing environment that supports holistic growth.

                We believe that every child is unique and capable of achieving excellence when guided with care and vision. Spacious classrooms, smart learning tools, well-equipped laboratories, libraries and dedicated activity rooms provide the foundation for academic growth.

                Sports and physical fitness are integral to our philosophy. With structured training in football, cricket, volleyball, taekwondo, athletics and more, students learn teamwork, discipline and perseverance.

                “The future belongs to those who believe in the beauty of their dreams.” – Eleanor Roosevelt"
              </p>

              <div className="principal-info">
                <h4>Mrs. Mili Mitra</h4>
                <p>Headmistress <br />TIGPS-ALIPURDUAR</p>
              </div>
            </div>



          </div>
        </div>
      </section>

      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* B) DOCUMENTS AND INFORMATION */}
          <h2 style={{ fontSize: '46px', fontWeight: '700', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora', color: 'rgb(100, 19, 32)' }}> TEACHER'S DETAILS</h2>
          <div className="table-responsive">
            <table style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={thStyle}>SL NO.</th>
                  <th style={thStyle}>NAME</th>
                  <th style={thStyle}>DESIGNATION</th>
                </tr>
              </thead>
              <tbody>
                {teamInfo.map((item) => (
                  <tr key={item.id}>
                    <td style={tdStyle}>{item.id}</td>
                    <td style={tdStyle}>{item.info}</td>
                    <td style={tdStyle}>{item.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>






    </>
  );
};

export default SchoolTeamPage;
